import BrandLaunch from './brandLaunch';
import FlashSale, { FlashSaleWithoutCountdown } from './flashSale';
import NewShopperActivity from './newShopperActivity';
export default function PromotionTag(props: { floors: any }) {
  const productPromotionFloor = props?.floors?.productPromotionFloor?.data;
  const { type, countdown, curTimeField, desc, promotionPop, promotionTimeText } =
    productPromotionFloor?.promotionInfo || {};
  const falshSale = productPromotionFloor?.promotionInfo?.desc
  const isFlashSale = type === 2;
  const isNewShopper = type === 51;

  return (
    <>
      {isFlashSale && (
        <>
          {' '}
          {countdown ? (
            <FlashSale countdown={countdown} curTimeField={curTimeField} saleTag={falshSale} />
          ) : (
            <FlashSaleWithoutCountdown saleTag={falshSale} />
          )}
        </>
      )}
      {/* @ts-ignore */}
      {isNewShopper && <NewShopperActivity label={desc} />}
      {/* 预约 */}
      {type === -6 && (
        <BrandLaunch
          desc={desc}
          promotionPop={promotionPop}
          promotionTimeText={promotionTimeText}
          countdown={countdown}
        />
      )}
    </>
  );
}
